import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AddIcon from "@mui/icons-material/Add";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, SoftFooter, SoftRowSkeleton, SoftTag, cls } from "../../hatim/soft/SoftKit";

/**
 * Sol sütun: yönettiğin hatimler. Mobildeki Hatimleri Yönet gibi: üstte
 * sabit açık özet şeridi, çizgiyle ayrılmış satırlar, altta sabit
 * "Hatim Oluştur".
 */
export default function HatimListPanel({ templates, selectedId, loading, onSelect, onCreate }) {
  const { t } = useScriptMode();

  return (
    <div
      className={`${cls.panel} overflow-hidden flex flex-col min-h-[320px] max-h-[calc(100vh-3rem)] lg:h-full lg:max-h-full lg:min-h-0`}
    >
      <div className={`shrink-0 flex items-center gap-3 px-4 py-3 ${cls.summary}`}>
        <span className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${cls.avatar}`}>
          <MenuBookOutlinedIcon sx={{ fontSize: 20 }} aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <div className={`text-lg font-SemiBold leading-tight ${cls.heading}`}>{t("hatim_mgmt_title")}</div>
          <div className={`text-xs leading-tight ${cls.muted}`}>
            {templates.length} {t("hatim_mgmt_count_suffix")}
          </div>
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto">
        {loading ? (
          <SoftRowSkeleton rows={4} />
        ) : templates.length === 0 ? (
          <div className="text-center py-10 px-4">
            <MenuBookOutlinedIcon sx={{ fontSize: 32 }} className={cls.faint} aria-hidden />
            <p className={`text-base mt-3 ${cls.muted}`}>{t("hatim_mgmt_empty_title")}</p>
          </div>
        ) : (
          <ul className="tk-stagger">
            {templates.map((tpl) => {
              const id = String(tpl._id);
              const active = id === String(selectedId);
              const userCount = Array.isArray(tpl.users) ? tpl.users.length : 0;
              return (
                <li key={id}>
                  <button
                    type="button"
                    data-template={id}
                    aria-pressed={active}
                    onClick={() => onSelect(id)}
                    className={[
                      "w-full text-left flex items-center gap-3 px-4 py-3 transition-colors",
                      cls.row,
                      active ? "bg-terakkiBrandCloud dark:bg-white/[0.08]" : cls.rowHover,
                    ].join(" ")}
                  >
                    <span
                      className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${cls.avatar}`}
                    >
                      <MenuBookOutlinedIcon sx={{ fontSize: 18 }} aria-hidden />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2 min-w-0">
                        <span className={`text-base font-SemiBold truncate ${cls.title}`}>{tpl.name}</span>
                        <SoftTag>{tpl.type}</SoftTag>
                      </span>
                      <span className={`block text-xs mt-0.5 truncate ${cls.muted}`}>
                        {userCount} {t("hatim_mgmt_card_users").toLowerCase()} · {t("hatim_mgmt_card_total").toLowerCase()} {tpl.totalAmount}
                      </span>
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <SoftFooter>
        <SoftButton tone="primary" fullWidth startIcon={<AddIcon fontSize="small" />} onClick={onCreate}>
          {t("hatim_mgmt_create_cta_short")}
        </SoftButton>
      </SoftFooter>
    </div>
  );
}
